module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }